import { useIsOnline } from '../lib/useIsOnline.js';

export function OfflineBanner() {
  const isOnline = useIsOnline();
  const offline = !isOnline;

  if (!offline) return null;
  return (
    <div
      role="alert"
      className="bg-warn text-ink py-2 px-4 text-center text-sm font-medium"
    >
      <span aria-hidden className="mr-2">⚠</span>
      You're offline. Reconnecting…
    </div>
  );
}
